import {
  Component,
  inject,
  Input,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';

import { DataObject } from '../../../models/core.models';

import {
  injectOutputLogsQuery,
  OutputLogsScope,
} from 'src/app/api/queries/utils-log.queries';

import { UtilsService } from 'src/app/core/services/utils.service';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-output-logs',
  templateUrl: './output-logs.component.html',
  styleUrl: './output-logs.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OutputLogsComponent {
  @Input() object: DataObject;

  private utilsService = inject(UtilsService);

  // Set in ngOnInit, once the @Input is available; the query idles until then.
  private readonly scope = signal<OutputLogsScope | null>(null);
  readonly outputLogsQuery = injectOutputLogsQuery(this.scope);

  ngOnInit(): void {
    if (this.object) {
      this.scope.set({
        objectId: this.object.id,
        objectClassId: this.object.object_class_id,
      });
    }
  }

  getFileTypeIcon(fileName: string): IconProp {
    return this.utilsService.getFileTypeIcon(fileName);
  }

  downloadLog(fileName: string): string {
    return this.utilsService.downloadFile(fileName);
  }
}
